<template>
  <client-only>
    <header class="detail-header">
      <div class="header-wrap">
        <div class="header-left">
          <img
            class="header-logo"
            width="140"
            height="20"
            src="https://s3.ap-northeast-2.amazonaws.com/cdn.insabank/header/kpi-header__logo.png"
            alt="header-logo"
            @click="onClickHeaderItem('/')"
          />
          <div
            v-for="(item, index) in headerItems"
            :key="'headerItem' + index"
            :class="['header-item', {on: item.selected}]"
            @click="onClickHeaderItem(item.path)"
          >
            {{ item.name }}
          </div>
        </div>
        <div>
          <div v-if="isAuthenticated" class="header-right">
            <div class="header-item" @click="onClickLogout">로그아웃</div>
            <div class="division" />
            <div class="header-item">마이페이지</div>
          </div>
          <div v-else class="header-right">
            <div class="header-item" @click="onClickHeaderItem('/login')">로그인</div>
            <div class="division" />
            <div class="header-item" @click="onClickHeaderItem('/signup')">회원가입</div>
          </div>
        </div>
      </div>
    </header>
  </client-only>
</template>
<script>
import {ref, onMounted} from 'vue'
import {useRoute} from 'vue-router'
import {useMemberStore} from '~/store/member/index.js'

export default {
  name: 'DetailHeader',
  setup() {
    const store = useMemberStore()
    const route = useRoute()

    const member = store.member
    const isAuthenticated = store.isAuthenticated
    const headerItems = ref([
      {name: '회원사업', path: '/membership-business', selected: false},
      {name: '공개강좌', path: '/seminar?menu=0&subMenu=0', selected: false},
      {name: '월간인사관리', path: '/magazine?menu=0&subMenu=0', selected: false},
      {name: 'KPI 도서', path: '/kpi-book', selected: false},
      {name: 'HR 자료', path: '/hr', selected: false}
    ])

    onMounted(() => {
      // 컴포넌트가 마운트된 후에 실행됩니다
      const path = route.path
      headerItems.value.forEach(item => {
        if (item.path.includes(path)) {
          item.selected = true
        }
      })
    })

    return {
      store,
      member,
      isAuthenticated,
      headerItems
    }
  },
  methods: {
    onClickHeaderItem(path) {
      this.$router.push(path)
      // selected 변경
      this.headerItems.forEach(item => {
        item.selected = item.path.includes(path)
      })
    },
    onClickLogout() {
      if (confirm('로그아웃 하시겠습니까?')) {
        this.store.logout()
        window.location.reload()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.detail-header {
  border-bottom: 1px solid #f2f2f2;
}
.header-wrap {
  height: 52px;
  width: 960px;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  .header-left {
    display: flex;
    align-items: center;
    .header-logo {
      margin-right: 38px;
      cursor: pointer;
    }
    .header-item {
      font-family: 'Pretendard', sans-serif;
      font-size: 16px;
      font-weight: 600;
      margin-right: 48px;
      cursor: pointer;
      &.on {
        color: #0058aa;
      }
      &:hover {
        color: #0058aa;
      }
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    .header-item {
      font-family: 'Pretendard', sans-serif;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      &:hover {
        color: #0058aa;
      }
    }
    .division {
      width: 1px;
      height: 16px;
      background-color: #f2f2f2;
      margin: 0 12px;
    }
  }
}
</style>
